import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import Italian from "flatpickr/dist/l10n/it";
import { FlatpickrOptions } from "ng2-flatpickr";
import { AuthenticationService, UserService } from "../../../../auth/service";
import moment from "moment/moment";
import { TaskService } from "../../task.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UtilsService } from "../../../../auth/service/utils.service";
import { RoleService } from "../../../../auth/service/role.service";
import { HttpClient, HttpRequest } from "@angular/common/http";
import { ICurrentUser } from "app/auth/models/user-interface";

@Component({
  selector: "app-modal-add-task",
  templateUrl: "./add-task.component.html",
  styleUrls: ["./add-task.component.scss"],
})
export class ModalAddTaskComponent implements OnInit {
  @Output() callbackFn: EventEmitter<any> = new EventEmitter();

  public assignTo: string = "";

  public endDate_add: FlatpickrOptions;
  public employees_list: any = [];
  public formGroupAdd: FormGroup;
  @ViewChild("modalAddTask") modalAddTask: ElementRef;
  public files_list: any = [];
  public files_list_obj: any[] = [];
  public employee_limit: number = 3;
  public currentUser: ICurrentUser;
  public showModalErrors: boolean = false;
  public rolesList: any = [];

  constructor(
    private _httpClient: HttpClient,
    public _taskService: TaskService,
    private _userService: UserService,
    private _modalService: NgbModal,
    public _utilsService: UtilsService,
    public _formBuilder: FormBuilder,
    public _roleService: RoleService,
    private _authService: AuthenticationService,
  ) {}

  async ngOnInit() {
    this.currentUser = await this._authService.getCurrentUser();

    if (this._userService.allUserList.length < 1) {
      this.employees_list = await this._userService.addressBook();
    } else {
      this.employees_list = this._userService.allUserList;
    }

    this.endDate_add = {
      altFormat: "d/m/Y",
      minDate: "today",
      locale: Italian.it,
      altInput: true,
      utc: false,
      disableMobile: true,
    };

    this.formGroupAdd = this._formBuilder.group({
      title: new FormControl("", [Validators.required, Validators.minLength(3), Validators.maxLength(255)]),
      description: new FormControl("", [Validators.minLength(3), Validators.maxLength(65535)]),
      end_date: new FormControl(null),
      users: new FormControl(null),
      group: new FormControl(null),
      role: new FormControl(null),
      priority: new FormControl(0),
    });

    this._modalService.open(this.modalAddTask, {
      centered: true,
      backdrop: false,
      size: "lg",
      keyboard: false,
      beforeDismiss: () => {
        this.formGroupAdd.reset();
        this.callbackFn.emit();
        return true;
      },
    });

    // se ho il diritto posso assegnare a più di 3 dipendenti
    if (this._authService.hasCapability("assign_task_to_more_employee")) {
      this.employee_limit = 9999999;
    }

    this.rolesList = this._roleService.list.filter((item: any) => item.name !== 'Dipendente');
  }

  setAddPriority(priority: number) {
    this.formGroupAdd.patchValue({ priority });
  }

  changeAssignTo(value: string) {
    // if(value === 'employee' || value === 'role' || value === 'group' ){
    //     this.formGroupAdd.controls['users'].setValidators([Validators.required])
    //     this.formGroupAdd.controls['group'].setValidators([Validators.required])
    //     this.formGroupAdd.controls['role'].setValidators([Validators.required])
    // } else {
    //     this.formGroupAdd.controls['users'].clearValidators()
    //     this.formGroupAdd.controls['group'].clearValidators()
    //     this.formGroupAdd.controls['role'].clearValidators()
    // }
    // this.formGroupAdd.controls['users'].updateValueAndValidity()
    // this.formGroupAdd.controls['group'].updateValueAndValidity()
    // this.formGroupAdd.controls['role'].updateValueAndValidity()

    if (value === this.assignTo) {
      return false;
    }
    this.formGroupAdd.patchValue({
      users: null,
      group: null,
      role: null,
    });
    this.assignTo = value;
  }

  assignToMySelf() {
    if (!this.formGroupAdd.value.users) {
      //Se il valore è null quindi quello inizializziamo l'array con l'hash
      this.formGroupAdd.patchValue({
        users: [this.currentUser.hash],
      });
    } else {
      if (!this.formGroupAdd.value.users.includes(this.currentUser.hash)) {
        //In questo caso è un array e prima controlliamo che già non ci sia l'hash dell'utente
        this.formGroupAdd.patchValue({ users: [...this.formGroupAdd.value.users, ...[this.currentUser.hash]] });
      }
    }
  }

  removeFileFromList(index: any) {
    this.files_list_obj = this.files_list_obj.filter((item: any, i: number) => i !== index);
    this.files_list = this.files_list.filter((item: any, i: number) => i !== index);
  }

  async addFileToList(files: any) {
    // creo una variabile dalla lista attuale
    let updatedList: any[] = this.files_list_obj.filter((item: any) => item.name !== "");
    // ciclo tutti i files inviati
    for (let file of files) {
      // controllo le dimensioni
      if (file.size > 10000000) {
        await this._utilsService.showSWALError({ text: "ERROR_MAX_FILE_SIZE" });
        continue;
      }
      // se esiste già nella lista lo tolgo
      const exists: any = updatedList.find((item: any) => item.name === file.name);
      // se esiste lo rimuovo
      if (exists) {
        updatedList = updatedList.find((item: any) => item.name === file.name);
      }
      // se non esiste lo metto nell'array dei files
      else {
        // aggiungo ai files
        this.files_list.push(file);
      }
      // aggiungo alla lista
      updatedList.push({
        name: file.name,
        size: this._utilsService.formatBytes(file.size),
        status: 0,
      });
    }
    // aggiorno variabile della pagina
    this.files_list_obj = updatedList;
  }

  fieldHasErrors(field_name: string): boolean {
    if (this.showModalErrors) {
      return this.formGroupAdd.controls[field_name].status === "INVALID";
    } else {
      return this.formGroupAdd.controls[field_name].status === "INVALID" && this.formGroupAdd.controls[field_name].touched;
    }
  }

  async save() {
    let data: any = this.formGroupAdd.value;

    this.showModalErrors = true;
    // controllo valori
    if (this.formGroupAdd.invalid) {
      return false;
    }

    if (data.end_date === null) {
      await this._utilsService.showSWALError({ text: "ERROR_ADD_TASK_MISSING_END_DATE" });
      return false;
    }

    if (data.title.length < 3) {
      await this._utilsService.showSWALError({ text: "ERROR_ADD_TASK_MISSING_TITLE" });
      return false;
    }

    if (data.users === null && data.group === null && data.role === null) {
      await this._utilsService.showSWALError({ text: "ERROR_ADD_TASK_MISSING_USER" });
      return false;
    }

    if (Array.isArray(data.end_date)) {
      data.end_date = moment(data.end_date[0]).format("YYYY-MM-DD");
    }

    if (data.description.length > 0) {
      data.description = data.description.replace(/\n/g, "<br>");
    }

    this._utilsService.showLoading();

    return this._taskService
      .create(data)
      .then(async (result: any) => {
        if (!result.id) {
          this._utilsService.hideLoading();
          await this._utilsService.showSWALError({ text: "ERROR_ADD_TASK" });
          return false;
        }

        for (let i = 0; i < this.files_list.length; i++) {
          const file: File = this.files_list[i];
          const formData: FormData = new FormData();
          formData.append("file", file);

          const req: any = new HttpRequest("POST", `/task/attachment/${result.id}`, formData);

          this.files_list_obj[i].status = 1;

          this._httpClient
            .request(req)
            .toPromise()
            .then(() => {
              this.files_list_obj[i].status = 2;
            })
            .catch((err: any) => {
              this.files_list_obj[i].status = 3;
              this.files_list_obj[i].error = err.toUpperCase().replace(/\s/gi, "_");
            });
        }

        const errorsCount: number = this.files_list_obj.filter((item: any) => item.status === 3).length;
        this._utilsService.hideLoading();
        if (errorsCount < 1) {
          this._modalService.dismissAll("Complete");
          this.callbackFn.emit();
          await this._utilsService.showSWALSuccess({ text: "SUCCESS_ADD_TASK" });
        } else {
          await this._utilsService.showSWALSuccess({ text: "TASK_ADDED_BUT_SOME_ATTACHMENT_NOT" });
        }
      })
      .catch(async () => {
        this._utilsService.hideLoading();
        await this._utilsService.showSWALError({ text: "ERROR_ADD_TASK" });
      });
  }
}
